module.exports = __webpack_public_path__ + "static/media/14UNEP7.f58880ad.jpg";